import { styled } from 'stitches.config'

export const WizardQuoteCardRoot = styled('div', {
  paddingLeft: '24px',
  paddingRight: '24px',
  paddingBottom: '0px',
  margin: 'auto',

  '@bp2': {
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: '48px',
  },
})

export const Card = styled('div', {
  background: '$tertiary-200',
  border: '1px solid $tertiary-300',
  borderRadius: '8px',
  padding: '12px 16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  width: '100%',
  margin: 'auto',
  maxWidth: '361px',

  '@bp2': {
    maxWidth: '462px'
  },
})

export const QuoteText = styled('p', {
  fontFamily: '$primary',
  fontWeight: '$medium',
  fontSize: '$body',
  lineHeight: '$body',
  color: '$accent-black',
  margin: 0,
})

export const Attribution = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
})

export const AvatarWrapper = styled('div', {
  flexShrink: 0,
  width: '40px',
  height: '40px',
  borderRadius: '9999px',
  overflow: 'hidden',
  position: 'relative',
  backgroundColor: 'white',
  border: '0.75px solid rgba(0,0,0,0.08)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const AuthorInfo = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const AuthorName = styled('p', {
  fontFamily: '$primary',
  fontWeight: '$medium',
  fontSize: '$small',
  lineHeight: '$small',
  color: '$accent-black',
  margin: 0,
})

export const AuthorTitle = styled('p', {
  fontFamily: '$primary',
  fontWeight: '$medium',
  fontSize: '$caption',
  lineHeight: '$caption',
  color: 'rgba(0,0,0,0.7)',
  margin: 0,
})
